import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
// @mui
import { styled, alpha } from '@mui/material/styles';
import {
  Box,
  Link,
  Drawer,
  Typography,
  Stack,
  Button,
  Chip
} from '@mui/material';

import useResponsive from '../../hooks/useResponsive';
import { useAuthAccess } from '../../hooks/useAuthAccess';

// components
import Scrollbar from '../../components/scrollbar';
import SidebarNav from './SidebarNav';
//
// import sidebarConfig from './SidebarConfig';
import { getSidebarConfigs, getSidebarLogo } from '../../configs/sidebarConfigs'

import CommonAvatarIcon from '../../components/common/CommonAvaterIcon';

import { routeTypes } from '../../hooks/useSystemRoutes'

// ----------------------------------------------------------------------

const NAV_WIDTH = 280;

const StyledAccount = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(2, 2.5),
  borderRadius: Number(theme.shape.borderRadius) * 1.5,
  backgroundColor: alpha(theme.palette.grey[500], 0.12),
}));

// ----------------------------------------------------------------------

Sidebar.propTypes = {
  openNav: PropTypes.bool,
  onCloseNav: PropTypes.func,
};

export default function Sidebar({ openNav, onCloseNav, navMinimize, t, showNavMinimizeButton, onToggleNavMinimize }) {

  // const { AvatarLabel } = useAvatarLabel()
  const { pathname } = useLocation();
  const { authData } = useAuthAccess();

  const isDesktop = useResponsive('up', 'lg');

  useEffect(() => {
    if (openNav) {
      onCloseNav();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  const renderContent = (
    <Scrollbar
      sx={{
        height: 1,
        '& .simplebar-content': { height: 1, display: 'flex', flexDirection: 'column' },
        // background: '#e1e1e1'
      }}
    >
      {
        getSidebarLogo({ t, routeType: routeTypes.driver })
      }

      <Box sx={{ mb: 5, mx: 2.5 }}>
        <Link underline="none">
          <StyledAccount>

            <CommonAvatarIcon />

            <Box sx={{ ml: 2 }}>
              <Typography variant="subtitle2" sx={{ color: 'text.primary' }}>
                {authData?.displayName}
              </Typography>

              <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                {authData?.profile?.user?.email}
              </Typography>
            </Box>
          </StyledAccount>
        </Link>
      </Box>

      <SidebarNav
        t={t}
        data={
          getSidebarConfigs({ routeType: routeTypes.driver })
        }
      />

      <Box sx={{ flexGrow: 1 }} />

      {
        showNavMinimizeButton &&

        <Box sx={{ px: 2.5, pb: 3, mt: 10 }}>
          <Stack alignItems="center" spacing={3} sx={{ pt: 5, borderRadius: 2, position: 'relative' }}>

            <Button
              target="_blank"
              variant="contained"
              onClick={onToggleNavMinimize}
            >
              {
                navMinimize ? "Minimize" : "Maximize"
              }
            </Button>
          </Stack>
        </Box>

      }
    </Scrollbar>
  );

  return (
    <Box
      component="nav"
      sx={{
        flexShrink: { lg: 0 },
        // width: { lg: NAV_WIDTH },
        width: navMinimize ? 'auto' : NAV_WIDTH
      }}
    >
      {/* {isDesktop ? ( */}
      {navMinimize === false ? (
        <Drawer
          open
          variant="permanent"
          PaperProps={{
            sx: {
              width: NAV_WIDTH,
              bgcolor: 'background.default',
              borderRightStyle: 'dashed',
            },
          }}
        >
          {renderContent}
        </Drawer>
      ) : (
        <Drawer
          open={openNav}
          onClose={onCloseNav}
          ModalProps={{
            keepMounted: true,
          }}
          PaperProps={{
            sx: { width: NAV_WIDTH },
          }}
        >
          {renderContent}
        </Drawer>
      )}

    </Box>
  );
}
